import React, { createContext, useContext, useState, useEffect } from "react";
import { languages, Language } from "./context.jsx"; // 모든 언어 데이터 가져오기
import { LanguageContext } from "./LanguageContext.jsx";
import { getInitialLang } from "./Init.jsx";

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitialLang()); // 상태 관리

  const setLang = (newLang) => {
    setLangState(newLang);
    localStorage.setItem(Language.LANG, newLang); // 언어 상태를 localStorage에 저장
  };

  useEffect(() => {
    const saved = localStorage.getItem(Language.LANG);

    if (saved && saved !== lang) {
      setLang(saved);
    }
  }, []);

  const dictionary = languages[lang] || languages[Language.KOREAN]; // 현재 언어에 맞는 번역본 선택

  const prefixMap = {
    [Language.ENGLISH]: "/api/en",
    [Language.CHINESE]: "/api/cn",
  };

  const prefix = prefixMap[lang] ?? "/api"; // 기본은 한국어

  return (
    <LanguageContext.Provider value={{ lang, setLang, dictionary, prefix }}>
      {children}
    </LanguageContext.Provider>
  );
};
